<div class="headerCont" #headerCont>
    <div class="rightcont">
        <div class="heading">
            <app-ng-dynamic-breadcrumb class="breadCrumb" symbol="/"></app-ng-dynamic-breadcrumb>
        </div>
        <ng-container *ngIf="leftButtons?.length">
            <div *ngFor="let button of leftButtons">
                <div *ngIf="button?.type === 'text-toggle'" class="header-text-toggle">
                    <div class="text-toggle-wrapper">
                        <span class="text-toggle-option" 
                              [class.active]="button?.currentValue === 'Placement'"
                              (click)="tabChange(button, 'Placement')">
                            Placement
                        </span>
                        <span class="text-toggle-divider">|</span>
                        <span class="text-toggle-option" 
                              [class.active]="button?.currentValue === 'Internship'"
                              (click)="tabChange(button, 'Internship')">
                            Internship
                        </span>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="leftcont">
        <ng-container *ngIf="rightButtons?.length">
            <div *ngFor="let button of rightButtons">
                <div *ngIf="button?.type === 'button'" class="drives-top">
                    <p-button [pTooltip]="button?.tooltip" tooltipPosition="bottom" [label]="button.label"
                        [icon]="button.icon" (onClick)="button.action()" class="header-btn">
                    </p-button>
                </div>
            </div>
        </ng-container>

        <div class="search-container">
            <i class="pi pi-search search-icon" (click)="openSearchDialog()"></i>
        </div>

        <div class="bell-container">
            <span class="bell-icon pi pi-bell" (click)="openNotification()"></span>
            <div class="badge" *ngIf="notificationService.notificationCount">{{notificationService.notificationCount}}
            </div>
        </div>

        <div class="header-separator"></div>

        <div class="user-profile" (click)="moreFilter.toggle($event)" style="cursor: pointer;">
            <div class="user-image">
                <img [src]="selectedImage" alt="user-profile" />
            </div>
            <div class="user-name">
                {{userData ? userData?.first_name + ' ' + userData?.last_name : ''}}
                <i class="down-arrow pi pi-chevron-down"></i>
            </div>
        </div>

        <p-overlayPanel #moreFilter>
            <ng-template pTemplate="content">
                <div class="overlay-cnt">
                    <div *ngFor="let options of actionOptions">
                        <span class="action-option" (click)="onClick(options)"><i class="pi {{options.icon}}"></i>
                            {{options.label}}</span>
                    </div>
                </div>
            </ng-template>
        </p-overlayPanel>
    </div>
    <p-sidebar [appendTo]="'body'" [style]="{width: '40vw'}" [(visible)]="profileSidebar" position="right"
        [dismissible]="false" (onHide)="onCloseSideBar()">
        <ng-template pTemplate="header">
            <div class="header-top">
                <span style="font-size: 22px;">Profile</span>
                <button pbutton class="p-button-create blue-filled-btn" (click)="onEditProfile()" type="submit">
                    Update</button>
            </div>
            <p-divider [ngStyle]="{'width': '100%'}" layout="horizontal"></p-divider>
        </ng-template>
        <ng-template pTemplate="body">
            <ng-container *ngIf="isLoading ; then loader ;else nonLoader"></ng-container>
            <ng-template #loader>
                <p-progressSpinner class="loading-spinner"></p-progressSpinner>
                <!-- <app-loading-animation [overlay]="true"></app-loading-animation> -->
            </ng-template>
            <ng-template #nonLoader>
                <div class="flex">
                    <input #fileInput type="file" (change)="onFileSelected($event , 'school')" accept="image/*"
                        style="display: none;">
                    <div *ngIf="selectedImage" class="image-preview"
                        [ngStyle]="{'background-image': 'url(' + profilePicBackground + ')'}">
                        <img [src]="selectedImage" alt="Preview">
                    </div>
                    <button [ngClass]="{ 'side-upload': selectedImage}" label="Primary"
                        class="p-button-create blue-outlined-btn" (click)="fileInput.click()">
                        {{selectedImage ? 'Re-Upload' : 'Upload'}}
                    </button>
                </div>
                <div style="display: flex; flex-direction: column ;gap: 5px; margin-top: 30px;">
                    <form style="display: flex; flex-direction: column;" class="createform" [formGroup]="profileFields"
                        type="submit" id="create-student">
                        <div class="flex-container" style="gap: 20px;" id="input-width">
                            <ng-container *ngFor="let row of profileDetails; let i = index">
                                <span *ngIf="row.type !== 'editor'" class="create-fields"
                                    style="display: flex; gap: 10px; font-size: var(--fs-medium);">
                                    <label for="inputtext">{{row.label}}<span class="imp">*</span></label>
                                    <input style="width: 30vw;font-size: var(--fs-medium);"
                                        [ngStyle]="{'cursor': !row.disable ? 'auto' : 'not-allowed'}"
                                        formControlName="{{row.controlfield}}" pInputText [readonly]="row.disable">
                                </span>
                            </ng-container>
                        </div>
                    </form>
                </div>
            </ng-template>
        </ng-template>
    </p-sidebar>
</div>

<!-- Search Dialog -->
<p-dialog [(visible)]="showSearchDialog" [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
    [style]="{width: '700px'}" [header]="'Search Modules, Students & Drives'" (onHide)="closeSearchDialog()"
    [appendTo]="'body'">
    <div class="search-dialog-content">
        <!-- Search Input -->
        <div class="search-input-wrapper">
            <!-- <i class="pi pi-search search-icon"></i> -->
            <input #searchInput type="text" class="search-input" placeholder="Search modules, students, or drives..."
                [(ngModel)]="searchQuery" (input)="onSearchInput()" (keydown)="onSearchKeydown($event)" autofocus />
            <!-- <i *ngIf="searcHere hQuery" class="pi pi-times clear-search" (click)="clearSearch()"></i> -->
        </div>

        <!-- Loading State -->
        <div *ngIf="isSearching" class="search-loading">
            <i class="pi pi-spin pi-spinner"></i>
            <span>Searching...</span>
        </div>

        <!-- Search Results -->
        <div class="search-results-container" *ngIf="!isSearching">
            <div *ngIf="searchQuery && getTotalResults() > 0" class="search-results-grouped">

                <!-- Modules Section -->
                <div *ngIf="searchResults.modules.length > 0" class="search-category">
                    <div class="category-header">
                        <i class="pi pi-th-large"></i>
                        <span>Modules</span>
                    </div>
                    <div class="search-results-list">
                        <div *ngFor="let module of searchResults.modules; let i = index" class="search-result-item"
                            (click)="navigateToModule(module)" [class.highlighted]="i === highlightedIndex"
                            (mouseenter)="highlightedIndex = i">
                            <div class="module-result-icon result-icon">
                                <img [src]="module.icon" alt="" />
                            </div>
                            <div class="result-content">
                                <div class="result-title">{{ module.label }}</div>
                                <div class="result-description">{{ module.description }}</div>
                            </div>
                            <div class="result-route">{{ module.route }}</div>
                        </div>
                    </div>
                </div>

                <!-- Students Section -->
                <div *ngIf="searchResults.students.length > 0" class="search-category">
                    <div class="category-header">
                        <i class="pi pi-users"></i>
                        <span>Students</span>
                        <span *ngIf="additionalResults.students > 0" class="more-count">+{{ additionalResults.students
                            }} more</span>
                    </div>
                    <div class="search-results-list">
                        <div *ngFor="let student of searchResults.students; let i = index"
                            class="search-result-item student-result" (click)="navigateToModule(student)"
                            [class.highlighted]="i === highlightedIndex" (mouseenter)="highlightedIndex = i">
                            <div class="result-icon">
                                <ng-container *ngIf="getProfileImage(student); else fallbackAvatar">
                                    <img [src]="getProfileImage(student)" [alt]="student.label"
                                        class="profile-summary-image" (error)="onProfileImgError($event)" />
                                </ng-container>
                                <ng-template #fallbackAvatar>
                                    <div class="profile-fallback-avatar"
                                        [ngStyle]="{ 'background-color': getProfileColor(student), 'color': getProfileTextColor(student) }">
                                        {{ getProfileInitial(student) }}
                                    </div>
                                </ng-template>
                            </div>
                            <div class="result-content">
                                <div class="result-title">{{ student.label }}</div>
                                <div class="result-description">{{ student.description }}</div>
                            </div>
                            <div [ngClass]="'result-type ' + student.status?.replaceAll(' ', '_')">{{ student.status }}</div>
                        </div>
                    </div>
                </div>

                <!-- Drives Section -->
                <div *ngIf="searchResults.drives.length > 0" class="search-category">
                    <div class="category-header">
                        <i class="pi pi-briefcase"></i>
                        <span>Drives</span>
                        <span *ngIf="additionalResults.drives > 0" class="more-count">+{{ additionalResults.drives }}
                            more</span>
                    </div>
                    <div class="search-results-list">
                        <div *ngFor="let drive of searchResults.drives; let i = index"
                            class="search-result-item drive-result" (click)="navigateToModule(drive)"
                            [class.highlighted]="i === highlightedIndex" (mouseenter)="highlightedIndex = i">
                            <div class="result-icon">
                                <ng-container *ngIf="getProfileImage(drive); else fallbackAvatar">
                                    <img [src]="getProfileImage(drive)" [alt]="drive.label"
                                        class="profile-summary-image" (error)="onProfileImgError($event)" />
                                </ng-container>
                                <ng-template #fallbackAvatar>
                                    <div class="profile-fallback-avatar"
                                        [ngStyle]="{ 'background-color': getProfileColor(drive), 'color': getProfileTextColor(drive) }">
                                        {{ getProfileInitial(drive) }}
                                    </div>
                                </ng-template>
                            </div>
                            <div class="result-content">
                                <div class="result-title">{{ drive.label }}</div>
                                <div class="result-description">{{ drive.description }}</div>
                            </div>
                            <div [ngClass]="'result-type ' + drive.status?.replaceAll(' ', '_')">{{ drive.status }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- No Results Message -->
            <div *ngIf="searchQuery && getTotalResults() === 0" class="search-no-results">
                <i class="pi pi-search"></i>
                <span>No results found for "{{ searchQuery }}"</span>
                <p>Try searching with different keywords or check the spelling.</p>
            </div>

            <!-- Initial State -->
            <div *ngIf="!searchQuery" class="search-initial-state">
                <div class="search-tips">
                    <h4>Search Tips:</h4>
                    <ul>
                        <li>Search by module name (e.g., "students", "drives")</li>
                        <li>Search by student email or drive name</li>
                        <li>Search by functionality (e.g., "email", "reports")</li>
                    </ul>
                </div>
                <div class="popular-modules">
                    <h4>Popular Modules:</h4>
                    <div class="popular-modules-grid">
                        <button *ngFor="let module of popularModules" class="popular-module-btn"
                            (click)="navigateToModule(module)">
                            <img [src]="module.icon" alt="" />
                            <span>{{ module.label }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</p-dialog>

<div class="notification">
    <p-sidebar class="download-sidebar" [modal]="true" id="notification" [appendTo]="'body'" (onHide)="closeDialog()" [style]="{width: '35vw'}"
        [(visible)]="showNotification" position="right" [dismissible]="false">
        <ng-template pTemplate="header">
            <div class="sidebar-header-cont" id="notification-header">
                <div class="notify-cont">
                    <span>Notifications</span>
                    <label class="flex align-center" (click)="markAllAsRead()"
                        style="color: var(--clr-primary-dark); cursor: pointer; font-size: 0.85rem;"><u>Mark all as
                            read</u></label>
                </div>
            </div>
            <p-divider layout="horizontal"></p-divider>
        </ng-template>
        <ng-template pTemplate="body">
            <div class="sidebar-body">
                <div *ngFor="let item of notificationService.notificationData"
                    class="flex gap-30 width100 notification-loop">
                    <div class="notification-container" [ngClass]="{'unread': item.status === 'unread', 'read': item.status === 'read'}">
                        <div class="field-name">
                            <img [src]="getIconSrc(item.s3link)" alt="File Icon">
                            <div [pTooltip]="item.title?.length > 30 ? item.title : null"
                                tooltipPosition="top">
                                {{ item.title.length > 40 ? item.title.substring(0, 40) + '...' : item.title }}
                            </div>
                        </div>
                        
                        <div class="notification-download-box">
                            <span *ngIf="item.s3link" class="download-notification-data"
                                (click)="fileAction(item)">Download</span>
                            <span class="pi pi-trash delete-icon" (click)="deleteNotification(item)"></span>
                        </div>
                        
                        <div class="date-time">
                            <span>{{item.createdAt | date: dateFormat }}</span>
                        </div>
                    </div>
                </div>
                <div *ngIf="notificationService.notificationData.length === 0" class="no-notification">
                    <span class="empty-notification">No New Notifications</span>
                </div>
            </div>
        </ng-template>
    </p-sidebar>
</div>
<p-toast></p-toast>